import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { GoogleMapComponentDef } from '@df/module-google-maps/google-map/google-map.component.def';
import { GoogleMaps } from '@df/module-google-maps/google-maps.namespace';

declare module '@df/module-google-maps/google-map/google-map.component.def' {
    interface IMarkerOptions {
        storeId?: number;
    }
}

@Component({
    selector: 'google-map',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: ''
})
export class GoogleMapComponent extends GoogleMapComponentDef {
    @Output() storeSelected = new EventEmitter<number>();

    protected override onMarkerClick(markerSetup: GoogleMaps.IMarkerOptions): void {
        const storeId = markerSetup.storeId;

        if (storeId != undefined) {
            this.storeSelected.emit(storeId);

            if (markerSetup.position) {
                this.googleMap.setCenter(markerSetup.position);
            }
        }
    }
}
